import React from 'react';

interface ConstellationLoaderProps {
  isVisible: boolean;
}

export const ConstellationLoader: React.FC<ConstellationLoaderProps> = ({ isVisible }) => {
  return (
    <div className={`fixed inset-0 bg-background flex items-center justify-center z-50 transition-opacity duration-500 ${
      isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
    }`}>
      {/* Constellation Background */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Generate constellation stars */}
        {Array.from({ length: 50 }).map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-primary/30 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: `${Math.random() * 3 + 1}px`,
              height: `${Math.random() * 3 + 1}px`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${Math.random() * 2 + 2}s`
            }}
          />
        ))}
        
        {/* Connecting lines for constellation effect */}
        <svg className="absolute inset-0 w-full h-full opacity-20">
          <defs>
            <pattern id="constellation" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
              <line x1="20" y1="20" x2="60" y2="80" stroke="hsl(var(--primary))" strokeWidth="0.5" opacity="0.3">
                <animate attributeName="opacity" values="0.1;0.5;0.1" dur="4s" repeatCount="indefinite" />
              </line>
              <line x1="60" y1="80" x2="120" y2="40" stroke="hsl(var(--primary))" strokeWidth="0.5" opacity="0.3">
                <animate attributeName="opacity" values="0.1;0.5;0.1" dur="3s" repeatCount="indefinite" />
              </line>
              <line x1="120" y1="40" x2="180" y2="120" stroke="hsl(var(--primary))" strokeWidth="0.5" opacity="0.3">
                <animate attributeName="opacity" values="0.1;0.5;0.1" dur="5s" repeatCount="indefinite" />
              </line>
              <line x1="40" y1="160" x2="140" y2="180" stroke="hsl(var(--primary))" strokeWidth="0.5" opacity="0.3">
                <animate attributeName="opacity" values="0.1;0.5;0.1" dur="3.5s" repeatCount="indefinite" />
              </line>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#constellation)" />
        </svg>
      </div>

      {/* FOMO Logo and Loading Text */}
      <div className="relative z-10 text-center animate-scale-in">
        <div className="mb-8">
          <img 
            src="https://guwcqpytunuquoirejsc.supabase.co/storage/v1/object/public/fomo-assets/fomo_2025.png"
            alt="FOMO Logo"
            className="h-24 md:h-32 w-auto mx-auto animate-pulse"
          />
          <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent mx-auto mt-6 animate-pulse" />
        </div>
        
        <div className="flex flex-col items-center space-y-4">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          <p className="text-sm text-muted-foreground animate-pulse">
            Social Media Ecosystem
          </p>
        </div>
      </div>
      
      {/* Orbital rings around logo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="relative">
          <div className="w-32 h-32 border border-primary/20 rounded-full animate-spin" style={{ animationDuration: '8s' }} />
          <div className="absolute inset-2 w-28 h-28 border border-primary/10 rounded-full animate-spin" style={{ animationDuration: '12s', animationDirection: 'reverse' }} />
          <div className="absolute inset-6 w-20 h-20 border border-primary/5 rounded-full animate-spin" style={{ animationDuration: '6s' }} />
        </div>
      </div>
    </div>
  );
};